export default __webpack_public_path__ + "static/media/beeLightHoneyDesktop.d6eef667.jpg";